import * as React from 'react';
import { CircularProgress, Skeleton } from '@mui/material';

const ModuleLoader: React.FC = () => (
  <div className="flex items-center justify-center w-full h-full">
    <CircularProgress size="2rem" color="primary" />
  </div>
);

const ProfileLoader: React.FC<{ height?: number; hasButton?: boolean }> = ({
  height = 450,
  hasButton = true,
}) => (
  <div className="space-y-6">
    <Skeleton animation="wave" variant="rounded" height={height} className="rounded-xl" />
    {hasButton && (
      <Skeleton
        animation="wave"
        variant="rounded"
        height={48}
        width={190}
        className="rounded-lg ml-auto"
      />
    )}
  </div>
);

const ProfileSubscriptionLoader: React.FC = () => (
  <div className="space-y-6">
    <Skeleton animation="wave" variant="rounded" height={370} className="rounded-xl" />
    <Skeleton animation="wave" variant="rounded" height={166} className="rounded-xl" />
  </div>
);

const ProfileInstrumentLoader: React.FC = () => (
  <div className="space-y-6 text-center">
    <div className="space-y-2">
      <Skeleton animation="wave" variant="rounded" height={100} className="rounded-xl" />
      <Skeleton animation="wave" variant="rounded" height={100} className="rounded-xl" />
      <Skeleton animation="wave" variant="rounded" height={100} className="rounded-xl" />
    </div>
    <Skeleton variant="text" sx={{ fontSize: '2rem', width: '50%', margin: 'auto' }} />
    <Skeleton animation="wave" variant="rounded" height={200} className="rounded-xl" />
  </div>
);

export { ModuleLoader, ProfileLoader, ProfileSubscriptionLoader, ProfileInstrumentLoader };
